import {createEntityAdapter} from '@reduxjs/toolkit'
import { ITransactionStatus } from '../../types'

export const transactionStatusesAdapter = createEntityAdapter<ITransactionStatus>()